var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PropTypes } from 'react';
import { default as ReactModal2 } from 'react-modal2';
import { Gateway } from 'react-gateway';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: 'render',
    value: function render() {
      var modalClassName = 'cf-modal';

      if (this.props.type === 'confirm') {
        modalClassName += ' cf-modal--confirm';
      }

      if (this.props.width) {
        modalClassName += ' cf-modal--' + this.props.width;
      }

      return React.createElement(
        Gateway,
        { into: 'modal' },
        React.createElement(
          ReactCSSTransitionGroup,
          {
            transitionName: 'cf-transition-modal',
            transitionAppear: true,
            transitionAppearTimeout: 200,
            transitionEnterTimeout: 200,
            transitionLeaveTimeout: 200
          },
          this.props.isOpen && React.createElement(
            'div',
            { className: 'cf-modal__backdrop-scroller' },
            React.createElement(
              'div',
              { className: 'cf-modal__backdrop-outer' },
              React.createElement(
                ReactModal2,
                {
                  key: 'modal',
                  backdropClassName: 'cf-modal__backdrop',
                  modalClassName: modalClassName,
                  closeOnEsc: this.props.closeOnEsc,
                  closeOnBackdropClick: this.props.closeOnBackdropClick,
                  onClose: this.props.onRequestClose
                },
                this.props.children
              )
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(React.Component);

Modal.propTypes = {
  type: PropTypes.oneOf(['confirm']),
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  closeOnEsc: PropTypes.bool,
  closeOnBackdropClick: PropTypes.bool,
  children: PropTypes.node,
  width: PropTypes.string
};

Modal.defaultProps = {
  closeOnEsc: true,
  closeOnBackdropClick: true
};

export default Modal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-modal/es/Modal.js
// module id = 778
// module chunks = 0